export default "__VITE_ASSET__BW9bCzhh__"